import React from "react";
import fieldPropTypes from "./field-prop-types";

const isChecked = (field, value) => {
  if ("options" in field) {
    const selectedOption = field.options.find(option =>
      value ? option.value === value : option.selected
    );
    return selectedOption && selectedOption.name === "Y";
  } else {
    return false;
  }
};

class CellWithSwitch extends React.Component {
  handleSwitchChange = () => {
    const { field, appData } = this.props;
    const checked = isChecked(field, appData.values[field.name]) || false;

    const selectedOption = field.options.find(option =>
      !checked ? option.name === "Y" : option.name === "N"
    );

    appData.handleSwitchChange(field.name, selectedOption);

    field.options.forEach(option => {
      option.selected = !option.selected;
    });
  };

  render() {
    const {
      field,
      components: { Switch },
      appData
    } = this.props;
    return (
      <Switch
        checked={isChecked(field, appData.values[field.name]) || false}
        labelText={field.title}
        onChange={this.handleSwitchChange}
        identifier={field.name}
      />
    );
  }
}

CellWithSwitch.propTypes = fieldPropTypes;

export default CellWithSwitch;
